import React from 'react';
import { Tooltip } from 'antd';
import type { TooltipProps } from 'antd';

/**
 * StructuredEditor 统一 tooltip：深底（#0A0A0A）白字圆角卡片，无箭头。
 *
 * 文本换行策略：maxWidth: 320 + whiteSpace: normal + wordBreak: break-word。
 *   - 短/中等内容：内容撑不到 maxWidth，inline-block 自然单行。
 *   - 长内容（如超长文件名）：到 maxWidth 自动换行，break-word 兜住超长 token。
 */
const OVERLAY_INNER_STYLE: React.CSSProperties = {
  background: '#0A0A0A',
  color: '#fff',
  fontSize: 12,
  padding: 12,
  borderRadius: 8,
  boxShadow: '0 4px 20px 0 rgba(129, 124, 143, 0.2)',
  maxWidth: 320,
  whiteSpace: 'normal',
  wordBreak: 'break-word',
};

export const SeTooltip: React.FC<TooltipProps> = ({
  children,
  placement = 'top',
  ...rest
}) => (
  <Tooltip
    {...rest}
    arrow={false}
    color="#0A0A0A"
    placement={placement}
    overlayInnerStyle={OVERLAY_INNER_STYLE}
  >
    {children}
  </Tooltip>
);
